import React from 'react';
import { connect } from 'react-redux';

const mapStateToProps = state => ({
   notifications: state.headerState.notifications,
});

function withNotifications(DisplayComponent) {
   const ComponentWithNotificationService = ({ notifications, ...passThrough }) => {
      return <DisplayComponent notifications={notifications} {...passThrough} />;
   };

   return connect(mapStateToProps)(ComponentWithNotificationService);
}

export default withNotifications;
